import {LitElement, html} from "lit";
import MutableValueMixin from "./Mixins/MutableValueMixin.js";
import {mix} from "mixwith";

export class PolymerMutationWrapper extends mix(LitElement).with(MutableValueMixin) {

	get InnerElement() {
		return this.firstElementChild;
	}

	constructor() {
		super();

		/**
		 * Holds the registered event listeners name and function.
		 *
		 * @type {[[string, function]]}
		 * @protected
		 */
		this._eventListeners = [];
	}

	register() {
		if(!this.ns) return;

		const element = this.InnerElement;
		if(!element) return;

		let initValue = undefined;

		const type = element.nodeName;
		switch(type) {
			case "PAPER-INPUT":
			case "NUMBER-INPUT":
			case "PAPER-TEXTAREA":
				initValue = element.value;
				super.register();
				this._eventListeners.push(["value-changed", e => this.value = e.detail.value]);
				break;

			case "PAPER-CHECKBOX":
				initValue = element.checked;
				super.register();
				this._eventListeners.push(["iron-change", e => this.value = element.checked]);
				break;

			case "PAPER-RADIO-GROUP":
				initValue = element.selected;
				super.register();
				this._eventListeners.push(["iron-select", e => this.value = element.selected]);
				this._eventListeners.push(["iron-deselect", e => this.value = null]);
				break;

			case "X-DROPDOWN":
			case "X-AJAX-DROPDOWN":
				initValue = element.value;
				super.register();
				this._eventListeners.push(["value-select", e => this.value = e.detail.value]);
				break;

			case "X-TOGGLE-SWITCH":
				initValue = element.active;
				super.register();
				this._eventListeners.push(["active-change", e => this.value = e.detail.active]);
				break;
		}

		if(this._beforeRender)
			this.value = initValue;

		this._eventListeners.forEach(listener => element.addEventListener(listener[0], listener[1]));
	}

	unregister() {
		if(!this.isRegistered())
			return;

		super.unregister();
		this._eventListeners.forEach(listener => element.removeEventListener(listener[0], listener[1]));
		this._eventListeners = [];
	}

	/*static get styles() {
		return css``;
	}*/

	render() {
		return html`<slot></slot>`;
	}

}

export default PolymerMutationWrapper;

customElements.define("polymer-mutation-wrapper", PolymerMutationWrapper);
